import { normalizeBoardHeaderData } from "../hooks/boardHeaderUtils";

export function getBoardNameTitle(boardNameDetails) {
  const board = normalizeBoardHeaderData(boardNameDetails);

  return board?.board_name?.substring(0, 3)?.toUpperCase() || "";
}

export function getEpicPermissions(boardNameDetails, isAdmin) {
  const board = normalizeBoardHeaderData(boardNameDetails);

  return {
    canCreateEpic:
      isAdmin() || board?.is_owner || board?.board_permission?.is_admin,
    canMergeMilestone: isAdmin() || board?.is_owner,
  };
}

export function groupEpics(epics = []) {
  return [...epics]
    .sort((epicA, epicB) => new Date(epicB.start_date) - new Date(epicA.start_date))
    .reduce(
      (accumulator, epic) => {
        if (epic.completed) {
          accumulator.completedMileStones.push(epic);
        } else {
          accumulator.unCompletedMileStones.push(epic);
        }

        return accumulator;
      },
      { completedMileStones: [], unCompletedMileStones: [] }
    );
}
